var _circle, _circle2, _path, _path2, _path3, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31.5,
    fill: "white",
    stroke: "#E0DEF7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 28,
    fill: "#E0DEF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 51C40 49.741 40.5928 48.5554 41.6 47.8L49.6 41.8C51.0222 40.7333 52.9778 40.7333 54.4 41.8L62.4 47.8C63.4072 48.5554 64 49.741 64 51V64H40V51Z",
    fill: "#097FE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.667 55.333C50.3937 55.333 50.167 55.5597 50.167 55.833V56.833C50.167 57.1063 50.3937 57.333 50.667 57.333C50.9403 57.333 51.167 57.1063 51.167 56.833V55.833C51.167 55.5597 50.9403 55.333 50.667 55.333Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6663 59.1668H57.9997V51.6535C57.9997 51.2401 57.813 50.8535 57.4863 50.6001L52.8197 46.9735C52.3397 46.5935 51.6597 46.5935 51.1797 46.9735L46.513 50.6001C46.1863 50.8535 45.9997 51.2401 45.9997 51.6468L45.9663 59.1668H45.333C45.0597 59.1668 44.833 59.3868 44.833 59.6668C44.833 59.9401 45.0597 60.1668 45.333 60.1668H58.6663C58.9397 60.1668 59.1663 59.9401 59.1663 59.6668C59.1663 59.3868 58.9397 59.1668 58.6663 59.1668ZM50.9997 49.5001H52.9997C53.273 49.5001 53.4997 49.7268 53.4997 50.0001C53.4997 50.2735 53.273 50.5001 52.9997 50.5001H50.9997C50.7263 50.5001 50.4997 50.2735 50.4997 50.0001C50.4997 49.7268 50.7263 49.5001 50.9997 49.5001ZM55.333 59.1668H48.6663V53.3335C48.6663 52.7801 49.113 52.3335 49.6663 52.3335H54.333C54.8863 52.3335 55.333 52.7801 55.333 53.3335V59.1668Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_243_2909)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_243_2909)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.333 26.6663V23.9997C21.333 23.2924 21.614 22.6142 22.1141 22.1141C22.6142 21.614 23.2924 21.333 23.9997 21.333H26.6663",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_243_2909)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.333 37.333V39.9997C21.333 40.7069 21.614 41.3852 22.1141 41.8853C22.6142 42.3854 23.2924 42.6663 23.9997 42.6663H26.6663",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.333 21.333H39.9997C40.7069 21.333 41.3852 21.614 41.8853 22.1141C42.3854 22.6142 42.6663 23.2924 42.6663 23.9997V26.6663",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.333 42.6663H39.9997C40.7069 42.6663 41.3852 42.3854 41.8853 41.8853C42.3854 41.3852 42.6663 40.7069 42.6663 39.9997V37.333",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0003 40L27.3337 33.3333C26.8844 32.5213 26.6548 31.6062 26.6675 30.6784C26.6802 29.7505 26.9347 28.842 27.406 28.0426C27.8773 27.2433 28.549 26.5807 29.3547 26.1204C30.1605 25.6601 31.0724 25.418 32.0003 25.418C32.9283 25.418 33.8402 25.6601 34.6459 26.1204C35.4516 26.5807 36.1233 27.2433 36.5946 28.0426C37.0659 28.842 37.3205 29.7505 37.3332 30.6784C37.3459 31.6062 37.1162 32.5213 36.667 33.3333L32.0003 40Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 30.667V30.6803",
    stroke: "#097FE6",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_243_2909",
    x: 18.333,
    y: 18.333,
    width: 15.333,
    height: 15.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.439216 0 0 0 0 0.396078 0 0 0 0 0.941176 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_243_2909"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_243_2909",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_243_2909",
    x: 18.333,
    y: 34.333,
    width: 15.333,
    height: 15.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.439216 0 0 0 0 0.396078 0 0 0 0 0.941176 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_243_2909"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_243_2909",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_243_2909"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectionIcon);
export default __webpack_public_path__ + "static/media/collection-icon.3198344c77e05b289df4b66e922aeeeb.svg";
export { ForwardRef as ReactComponent };